import client from './client'

export default {
  login: authInfo => client.post('/api/auth/login', authInfo),
  logout: () => client.delete('/api/auth/logout'),
  checkAuthToken: () => client.get('/api/authorization/check')
}
